/* FATCUTPRESS V3.0 — Barba continuous audio draft */
(() => {
  'use strict';
  const isThemeEditor = window.Shopify?.designMode === true && window.self !== window.top;
  if (isThemeEditor) return;
  if(!window.barba) return;

  const animate = (el, keyframes, options) => {
    if(!el || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return Promise.resolve();
    const animation = el.animate(keyframes, options);
    return animation.finished.catch(() => {});
  };

  function parseNext(html){ return new DOMParser().parseFromString(html, 'text/html'); }

  const LAST_NON_CART_KEY = 'fatcut:last-non-cart-url';

  function isCartURL(value){
    try{ return new URL(value, location.href).pathname === '/cart'; }catch(_error){ return false; }
  }

  function rememberNonCartURL(value){
    if(!value || isCartURL(value)) return;
    try{
      const url = new URL(value, location.href);
      if(url.origin === location.origin) sessionStorage.setItem(LAST_NON_CART_KEY, url.href);
    }catch(_error){}
  }

  function cartCloseDestination(){
    const saved = sessionStorage.getItem(LAST_NON_CART_KEY);
    if(saved && !isCartURL(saved)) return saved;
    try{
      if(document.referrer){
        const ref = new URL(document.referrer);
        if(ref.origin === location.origin && ref.pathname !== '/cart') return ref.href;
      }
    }catch(_error){}
    return `${location.origin}/collections/all`;
  }

  function closePersistentDrawer(){
    const layer = document.querySelector('[data-cart-layer]');
    if(!layer) return;
    layer.classList.remove('is-open','is-active');
    layer.setAttribute('aria-hidden','true');
    document.body.classList.remove('cart-drawer-open');
    document.querySelectorAll('[data-cart-toggle]').forEach(toggle => {
      toggle.classList.remove('is-cart-open');
      toggle.setAttribute('aria-expanded','false');
    });
  }

  function syncPersistentDrawer(){
    const layer = document.querySelector('[data-cart-layer]');
    if(!layer) return;
    closePersistentDrawer();
    layer.hidden = false;
    layer.setAttribute('aria-hidden','true');
  }


  function updateHeadAndBody(data){
    const doc = parseNext(data.next.html);
    document.title = doc.title;
    document.body.className = doc.body.className;
    ['data-template','data-has-products'].forEach(name => {
      const value = doc.body.getAttribute(name);
      if(value == null) document.body.removeAttribute(name); else document.body.setAttribute(name,value);
    });
    const nextCanonical = doc.querySelector('link[rel="canonical"]');
    const currentCanonical = document.querySelector('link[rel="canonical"]');
    if(nextCanonical && currentCanonical) currentCanonical.href = nextCanonical.href;
    const nextDescription = doc.querySelector('meta[name="description"]');
    const currentDescription = document.querySelector('meta[name="description"]');
    if(nextDescription && currentDescription) currentDescription.content = nextDescription.content;

    const player = document.querySelector('[data-void-mode]');
    if(player){
      const catalog = document.body.dataset.hasProducts === 'true';
      player.classList.toggle('is-catalog', catalog);
      player.classList.toggle('is-void', !catalog);
    }
    syncPersistentDrawer();
  }

  function runInlineScripts(container){
    container.querySelectorAll('script:not([type="application/json"])').forEach(oldScript => {
      const script = document.createElement('script');
      [...oldScript.attributes].forEach(attr => script.setAttribute(attr.name, attr.value));
      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });
  }

  let lightboxController = null;

  function destroyLightbox(){
    if(lightboxController){
      lightboxController.destroy();
      lightboxController = null;
    }

    document
      .querySelectorAll('[data-product-lightbox][data-barba-persistent-lightbox]')
      .forEach(node => node.remove());

    document.body.classList.remove('lightbox-open');
  }

  function setupDynamicLightbox(scope = document){
    destroyLightbox();

    const lightbox = scope.querySelector('[data-product-lightbox]');
    const galleryImages = [...scope.querySelectorAll(
      '.product-gallery--real-images .product-gallery__item img'
    )];

    if(!lightbox || !galleryImages.length) return;

    const image = lightbox.querySelector('[data-lightbox-image]');
    const current = lightbox.querySelector('[data-lightbox-current]');
    const total = lightbox.querySelector('[data-lightbox-total]');

    if(!image) return;

    lightbox.dataset.barbaPersistentLightbox = 'true';
    document.body.appendChild(lightbox);

    const abortController = new AbortController();
    const { signal } = abortController;
    let index = 0;
    let closeTimer = 0;

    total && (total.textContent = String(galleryImages.length));

    const show = nextIndex => {
      index = (nextIndex + galleryImages.length) % galleryImages.length;
      const source = galleryImages[index];
      image.src = source.currentSrc || source.src;
      image.alt = source.alt || '';
      current && (current.textContent = String(index + 1));
    };

    const open = nextIndex => {
      window.clearTimeout(closeTimer);
      show(nextIndex);
      lightbox.classList.remove('is-closing');
      lightbox.classList.add('is-active');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lightbox-open');
      requestAnimationFrame(() => lightbox.classList.add('is-open'));
    };

    const close = () => {
      if(!lightbox.classList.contains('is-active')) return;
      lightbox.classList.add('is-closing');
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lightbox-open');
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if(!lightbox.classList.contains('is-open')){
          lightbox.classList.remove('is-active', 'is-closing');
        }
      }, 520);
    };

    galleryImages.forEach((galleryImage, imageIndex) => {
      galleryImage.style.cursor = 'zoom-in';
      galleryImage.addEventListener('click', event => {
        event.preventDefault();
        open(imageIndex);
      }, { signal });
    });

    const handleLightboxClick = event => {
      const target = event.target;

      if(target.closest('[data-lightbox-prev]')){
        event.preventDefault();
        event.stopPropagation();
        show(index - 1);
        return;
      }

      if(target.closest('[data-lightbox-next]')){
        event.preventDefault();
        event.stopPropagation();
        show(index + 1);
        return;
      }

      if(
        target.closest('[data-lightbox-image]') ||
        target.closest('[data-lightbox-close]') ||
        target === lightbox
      ){
        event.preventDefault();
        close();
      }
    };

    const handleLightboxKeydown = event => {
      if(!lightbox.classList.contains('is-open')) return;

      if(event.key === 'Escape') close();
      if(event.key === 'ArrowLeft') show(index - 1);
      if(event.key === 'ArrowRight') show(index + 1);
    };

    // One delegated click path for mouse, touch and pen. This prevents the
    // pointerup/touchend/click cascade that previously froze iOS lightboxes.
    lightbox.addEventListener('click', handleLightboxClick, { signal });
    document.addEventListener('keydown', handleLightboxKeydown, { signal });

    lightboxController = {
      destroy(){
        window.clearTimeout(closeTimer);
        abortController.abort();
        document.body.classList.remove('lightbox-open');
        lightbox.remove();
      }
    };
  }

  function setupProductMediaReveal(scope = document, baseDelay = 60){
    const items = [...scope.querySelectorAll('.fatcut-product__media')];
    if(!items.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    items.forEach((item, index) => {
      item.classList.remove('is-fatcut-product-revealed');
      item.style.setProperty('--fatcut-product-reveal-delay', `${baseDelay + (index * 80)}ms`);
      item.dataset.productRevealReady = 'true';

      if(reduced){
        item.classList.add('is-fatcut-product-revealed');
        return;
      }

      // Force a fresh animation on initial load and every Barba entry.
      void item.offsetWidth;
      requestAnimationFrame(() => {
        item.classList.add('is-fatcut-product-revealed');
      });
    });
  }

  function setupMobileGallery(){
    document.querySelectorAll('[data-mobile-product-gallery]:not([data-barba-initialized])').forEach(gallery=>{
      gallery.dataset.barbaInitialized='true';
      const slides=[...gallery.querySelectorAll('.fatcut-product__media')];
      const current=gallery.parentElement?.querySelector('[data-mobile-gallery-current]');
      if(!current||slides.length<2)return;
      let ticking=false; const update=()=>{const width=gallery.clientWidth||1;current.textContent=String(Math.max(0,Math.min(slides.length-1,Math.round(gallery.scrollLeft/width)))+1);ticking=false};
      gallery.addEventListener('scroll',()=>{if(ticking)return;ticking=true;requestAnimationFrame(update)},{passive:true}); update();
    });
  }

  function setupPageFeatures(scope = document, revealDelay = 60){
    setupDynamicLightbox(scope);
    setupProductMediaReveal(scope, revealDelay);
    setupMobileGallery();
  }

  function initPage(container){
    runInlineScripts(container);
    window.FatcutThemeInit?.();
    setupPageFeatures(container, 500);
  }

  rememberNonCartURL(location.href);

  barba.hooks.before(({current}) => {
    rememberNonCartURL(current?.url?.href || location.href);
    destroyLightbox();
    closePersistentDrawer();
    document.documentElement.classList.add('is-barba-transitioning');
  });
  barba.hooks.after(() => document.documentElement.classList.remove('is-barba-transitioning'));

  syncPersistentDrawer();
  document.documentElement.classList.add('fatcut-barba-ready');
  setupPageFeatures();

  // The header cart is persistent and must open the drawer on every template,
  // including immediately after a Barba product transition. Capture the click
  // before any page-level handler can consume it.
  document.addEventListener('click', event => {
    const toggle = event.target.closest?.('[data-cart-toggle]');
    if(!toggle) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const layer = document.querySelector('[data-cart-layer]');
    const isOpen = layer?.classList.contains('is-open');

    const toggles = document.querySelectorAll('[data-cart-toggle]');

    if(isOpen){
      toggles.forEach(button => {
        button.classList.remove('is-cart-open');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', 'Open cart');
      });

      if(window.FatcutCart?.close){
        window.FatcutCart.close();
      }else if(layer){
        layer.classList.remove('is-open');
        layer.setAttribute('aria-hidden', 'true');
        window.setTimeout(() => layer.classList.remove('is-active'), 520);
      }
    }else{
      toggles.forEach(button => {
        button.classList.add('is-cart-open');
        button.setAttribute('aria-expanded', 'true');
        button.setAttribute('aria-label', 'Close cart');
      });

      if(window.FatcutCart?.open){
        window.FatcutCart.open();
      }else if(layer){
        layer.hidden = false;
        layer.classList.add('is-active');
        layer.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => requestAnimationFrame(() => layer.classList.add('is-open')));
      }
    }
  }, true);

  // Product pages can place gallery layers above part of the persistent header.
  // Use the visible bag / close glyph geometry as a capture-phase fallback so
  // the complete cart icon behaves exactly like it does on collection pages.
  document.addEventListener('click', event => {
    if(!document.body.classList.contains('template-product')) return;
    if(event.target.closest?.('[data-cart-toggle]')) return;
    const toggle = document.querySelector('[data-cart-toggle]');
    if(!toggle) return;

    const visibleControl = toggle.classList.contains('is-cart-open')
      ? toggle.querySelector('.fatcut-cart-close')
      : toggle.querySelector('.fatcut-cart-icon-wrap');
    const rect = (visibleControl || toggle).getBoundingClientRect();
    const padding = 12;
    const inside =
      event.clientX >= rect.left - padding &&
      event.clientX <= rect.right + padding &&
      event.clientY >= rect.top - padding &&
      event.clientY <= rect.bottom + padding;

    if(!inside) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const layer = document.querySelector('[data-cart-layer]');
    const isOpen = layer?.classList.contains('is-open');
    const toggles = document.querySelectorAll('[data-cart-toggle]');

    if(isOpen){
      toggles.forEach(button => {
        button.classList.remove('is-cart-open');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', 'Open cart');
      });
      window.FatcutCart?.close?.();
    }else{
      toggles.forEach(button => {
        button.classList.add('is-cart-open');
        button.setAttribute('aria-expanded', 'true');
        button.setAttribute('aria-label', 'Close cart');
      });
      window.FatcutCart?.open?.();
    }
  }, true);

  // Empty-cart SHOP / CONTINUE SHOPPING must never trigger a full reload.
  // Capture before Barba's own click handler and route through barba.go().
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-cart-continue-shopping]');
    if(!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    closePersistentDrawer();
    const destination = link.href || `${location.origin}/collections/all`;
    if(window.barba?.go){
      window.barba.go(destination);
    }else{
      location.href = destination;
    }
  }, true);

  barba.init({
    timeout:10000,
    preventRunning:true,
    prefetchIgnore:false,
    prevent:({el,href})=>{
      if(el?.hasAttribute('data-barba-prevent')) return true;
      if(!href) return true;
      const url=new URL(href,location.href);
      return url.origin!==location.origin || url.pathname.startsWith('/checkout') || url.pathname.startsWith('/account') || url.pathname.startsWith('/challenge');
    },
    transitions:[{
      name:'fatcut-background-hold',
      async leave({current}){
        const isProduct = current?.namespace === 'product' || current?.container?.closest?.('body.template-product') || document.body.classList.contains('template-product');
        const productMedia = isProduct ? [...current.container.querySelectorAll('.fatcut-product__media')] : [];

        if(productMedia.length){
          await Promise.all(productMedia.map((item,index) => animate(
            item,
            [
              {opacity:1,transform:'translateY(0) scale(1)'},
              {opacity:0,transform:'translateY(-8px) scale(.992)'}
            ],
            {
              duration:360,
              delay:index * 35,
              easing:'cubic-bezier(.4,0,.2,1)',
              fill:'forwards'
            }
          )));
        }

        await animate(current.container,[{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(-5px)'}],{duration:360,easing:'cubic-bezier(.4,0,.2,1)',fill:'forwards'});
      },
      beforeEnter(data){
        updateHeadAndBody(data);
        data.next.container.style.opacity='0';
        data.next.container.style.transform='translateY(8px)';
        window.scrollTo(0,0);
      },
      async enter({next}){
        initPage(next.container);
        syncPersistentDrawer();
        await animate(next.container,[{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:620,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'});
        next.container.getAnimations().forEach(animation => animation.cancel());
        next.container.style.opacity='';
        next.container.style.transform='';
        next.container.style.willChange='';
      }
    }]
  });

  const CHECKOUT_FADE_MS = 1500;
  let checkoutTransitionStarted = false;

  function fadeBeforeCheckout(action){
    if(checkoutTransitionStarted) return;
    checkoutTransitionStarted = true;

    document.documentElement.classList.add('is-checking-out');
    document.querySelectorAll('[data-void-mode]').forEach(player => {
      player.setAttribute('aria-hidden', 'true');
      player.inert = true;
    });

    /* Checkout always waits the full 1.5 seconds on both desktop and mobile.
       The timer is the navigation clock; the audio API performs the actual
       smooth volume fade during the same interval. */
    let completed = false;
    const finish = () => {
      if(completed) return;
      completed = true;
      action();
    };

    try{
      window.FatcutAudio?.fadeOut?.(CHECKOUT_FADE_MS);
    }catch(error){
      console.error(error);
    }

    window.setTimeout(finish, CHECKOUT_FADE_MS);
  }

  window.FatcutCheckout = {
    run: fadeBeforeCheckout,
    duration: CHECKOUT_FADE_MS
  };

  document.addEventListener('submit',event=>{
    const form=event.target;
    const submitter=event.submitter;
    const checkout=
      form.matches?.('[data-cart-checkout-form]') ||
      submitter?.name==='checkout' ||
      /\/checkout(?:$|[/?#])/.test(form.action||'');

    if(!checkout || form.dataset.audioFadeComplete==='true') return;

    event.preventDefault();
    fadeBeforeCheckout(()=>{
      form.dataset.audioFadeComplete='true';

      /* Preserve the clicked checkout submitter. Calling form.submit() drops
         name="checkout", which can return the customer to /cart instead of
         Shopify Checkout. requestSubmit(submitter) keeps the native checkout
         intent and the dataset flag prevents this handler from looping. */
      if(typeof form.requestSubmit==='function'){
        form.requestSubmit(submitter || undefined);
      }else{
        let checkoutField=form.querySelector('input[data-fatcut-checkout-field]');
        if(!checkoutField){
          checkoutField=document.createElement('input');
          checkoutField.type='hidden';
          checkoutField.name='checkout';
          checkoutField.value='Checkout';
          checkoutField.setAttribute('data-fatcut-checkout-field','');
          form.appendChild(checkoutField);
        }
        form.submit();
      }
    });
  },true);

  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href*="/checkout"]');
    if(!link || link.dataset.audioFadeComplete==='true') return;

    event.preventDefault();
    fadeBeforeCheckout(()=>{
      link.dataset.audioFadeComplete='true';
      location.href=link.href;
    });
  },true);
})();
